// extracted by mini-css-extract-plugin
export default {"error__container":"ErrorBoundary_error__container__p2cQG"};